<template>
    <div class="d-flex flex-column justify-content-between options-menu">
        <nav class="options-menu__nav">
            <ul class="options d-flex flex-row flex-wrap flex-lg-column justify-content-around options-menu__list">
                <app-page-options-item v-for="(option, index) in orderedOptions" :key="index" :to="option.to" :label="option.name" :icon="option.icon" />

                <li class="options__item corp-orange" v-if="!user.profile.client_side">
                    <router-link :to="{ name: 'documentation' }" class="d-flex align-items-center justify-content-start options__link--primary">
                        <span> Documentación</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
    import PageOptionsItem from './PageOptionsItem.vue';
    export default {
        components: {
            AppPageOptionsItem: PageOptionsItem
        },
        props: {
            options: {
                type: Array,
                required: true
            }
        },
        computed: {
            orderedOptions(){
                return this.options.sort((a, b) => a.order - b.order);
            }
        }
    }
</script>